import * as actionTypes from 'constants/ActionTypes';

export function getMailRecognizeSpamList() {
    return {
        type: actionTypes.GET_MAIL_RECOGNIZE_SPAM_LIST.REQUEST,
    };
}

export function createMailRecognizeSpamList(data) {
    return {
        type: actionTypes.CREATE_MAIL_RECOGNIZE_SPAM_LIST.REQUEST,
        data,
    };
}

export function updateMailRecognizeSpamList(data) {
    return {
        type: actionTypes.UPDATE_MAIL_RECOGNIZE_SPAM_LIST.REQUEST,
        data,
    };
}


// WEBPACK FOOTER //
// ./app/actions/preferences/mailRecognizeSpamList.js